export default class ProjectStage {
    parse(data) {
        this.id = data.id;
        this.name = data.name;
        return this;
    }
}
